<nb-card class="dialog">
  <nb-card-header>
    <h4>{{ key("title") | translate }}</h4>
  </nb-card-header>
  <nb-card-body>
    <p class="file">{{ fileName }}</p>

    <ng-container *ngIf="state === 'options'">
      <p class="label">{{ "pages.creator.import.kindLabel" | translate }}</p>
      <app-segmented-control
        [options]="kindOptions"
        [value]="kind"
        [ariaLabel]="'pages.creator.import.kindLabel' | translate"
        (valueChange)="kind = $any($event)"
      ></app-segmented-control>
      <p class="hint">{{ "pages.creator.import.documentHint" | translate }}</p>
    </ng-container>

    <ng-container *ngIf="state === 'uploading'">
      <p class="label">{{ key("uploading") | translate }}</p>
      <nb-progress-bar [value]="progress" status="primary" [displayValue]="true"></nb-progress-bar>
    </ng-container>

    <app-orbi-loader
      *ngIf="state === 'importing'"
      [size]="96"
      [label]="key('importing') | translate"
    ></app-orbi-loader>

    <div *ngIf="state === 'done' && result?.summary as summary" class="result" role="status">
      <p>
        {{ "pages.creator.import.done" | translate: { title: result?.title ?? fileName } }}
        {{ (summary.lessons === 1 ? "pages.creator.import.lessonsOne" : "pages.creator.import.lessons") | translate: { count: summary.lessons } }}
        {{ (summary.blocks === 1 ? "pages.creator.import.blocksOne" : "pages.creator.import.blocks") | translate: { count: summary.blocks } }}
      </p>
      <p *ngIf="summary.needsReview" class="hint">
        {{ (summary.needsReview === 1 ? "pages.creator.import.needsReviewOne" : "pages.creator.import.needsReview") | translate: { count: summary.needsReview } }}
      </p>
      <p *ngIf="summary.rejected" class="hint">
        {{ (summary.rejected === 1 ? "pages.creator.import.rejectedOne" : "pages.creator.import.rejected") | translate: { count: summary.rejected } }}
      </p>
    </div>

    <div *ngIf="state === 'confirm' && result?.summary as summary" class="result" role="alert">
      <p class="large-title">{{ "pages.creator.import.largeTitle" | translate }}</p>
      <p>{{ "pages.creator.import.large" | translate: { lessons: largeLessons, blocks: summary.blocks } }}</p>
      <p class="hint">{{ "pages.creator.import.largeHint" | translate }}</p>
    </div>

    <p *ngIf="state === 'failed'" class="error" role="alert">{{ errorKey | translate }}</p>
  </nb-card-body>
  <nb-card-footer>
    <button type="button" nbButton status="danger" outline (click)="close()">
      {{ (state === "uploading" || state === "options" || state === "confirm" ? "buttons.cancel" : "buttons.close") | translate }}
    </button>
    <button *ngIf="state === 'options'" type="button" nbButton status="primary" (click)="startDocument()">
      {{ "pages.creator.import.start" | translate }}
    </button>
    <button *ngIf="state === 'confirm'" type="button" nbButton status="primary" (click)="confirmLarge()">
      {{ "pages.creator.import.largeContinue" | translate }}
    </button>
    <button *ngIf="state === 'done'" type="button" nbButton status="primary" (click)="open()">
      {{ "pages.creator.import.open" | translate }}
    </button>
  </nb-card-footer>
</nb-card>
